import { render } from "./StringsLayoutsView.vue?vue&type=template&id=caf5bb86"
import script from "./StringsLayoutsView.vue?vue&type=script&lang=js"
export * from "./StringsLayoutsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__